import { render, staticRenderFns } from "./SwiperCarrousel.vue?vue&type=template&id=db421c8c&scoped=true&"
import script from "./SwiperCarrousel.vue?vue&type=script&lang=js&"
export * from "./SwiperCarrousel.vue?vue&type=script&lang=js&"
import style0 from "./SwiperCarrousel.vue?vue&type=style&index=0&id=db421c8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db421c8c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SwiperCarrouselSlide: require('/codebuild/output/src1887633789/src/kokalanov/components/SwiperCarrouselSlide.vue').default})
